import { gql } from "@apollo/client";

export const GET_TEAMMEMBERS = gql`
query getTeamMembers($pageOptions: PageOptions,$filters: [Filters], $sortOptions: [SortOptions]) {
    getTeamMembers(pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions) {
        teamMember {
            arcimedes_row_id,
            first_name
            last_name
            title
            phone
            linkedin
            email
            description
            photo
            credentials
            is_agent
            deleted
            is_admin
            visible_on_website
            starting_date
            termination_date
            yrs_at_strive
            birth_date
            age
            on_phones
            in_pool
            first_listing
            first_closing
            address
            city
            state
            zip
            cell_phone
            territory
            w4_form
            w9_form
            payroll_form
            ca_form
            it_policy_form
            trade_secrets_form
            arcimedes_created
            arcimedes_created_by
            arcimedes_modified
            arcimedes_modified_by
        }
        totalCount
    }
}
`

export const GET_TEAMMEMBER_BY_ID = gql`
query getTeamMemberById($arcimedes_row_id: ID!){
    getTeamMember(arcimedes_row_id: $arcimedes_row_id){
        arcimedes_row_id,
        first_name
        last_name
        title
        phone
        linkedin
        email
        description
        photo
        credentials
        is_agent
        deleted
        is_admin
        visible_on_website
        starting_date
        termination_date
        yrs_at_strive
        birth_date
        age
        on_phones
        in_pool
        first_listing
        first_closing
        address
        city
        state
        zip
        cell_phone
        territory
        w4_form
        w9_form
        payroll_form
        ca_form
        it_policy_form
        trade_secrets_form
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
    }
}
`

export const GET_UNIQUE_TERRITORIES = gql`
query uniqueTerritories($pageOptions: PageOptions) {
    uniqueTerritories(pageOptions: $pageOptions) 
}
`

export const GET_STRIVE_AGENT_FIRST_LISTING = gql`
query striveAgentFirstListing($pageOptions: PageOptions, $agentId: ID!) {
    striveAgentFirstListing(pageOptions: $pageOptions, agent_id: $agentId)
}
`

export const GET_HSC_MEMBER_LISTING_CLOSING_DATES = gql`
query hscMemberListingClosingDates($hscTeamMember: String!) {
    hscMemberListingClosingDates(hscTeamMember: $hscTeamMember)
}
`

// export const GET_ALL_TEAMMEMBERS = gql`   //old query
// query getAllTeamMembers($filters: [Filters]) {
//     getAllTeamMembers(filters: $filters) {
//             arcimedes_row_id,
//             first_name
//             last_name
//             title
//             phone
//             linkedin
//             email
//             description
//             photo
//             credentials
//             is_agent
//             deleted
//             is_admin
//             visible_on_website
//             starting_date
//             termination_date
//             yrs_at_strive
//             birth_date
//             age
//             on_phones
//             in_pool
//             first_listing
//             first_closing
//             address
//             city
//             state
//             zip
//             cell_phone
//             territory
//             w4_form
//             w9_form
//             payroll_form
//             ca_form
//             it_policy_form
//             trade_secrets_form
//             arcimedes_created
//             arcimedes_created_by
//             arcimedes_modified
//             arcimedes_modified_by
//     }
// }
// `

// pavani asked to removed  fields and send SS to me has the api is working
export const GET_ALL_TEAMMEMBERS = gql` 
query getAllTeamMembers {
  getAllTeamMembers {
    arcimedes_row_id
    first_name
    last_name
    title
    phone
    email
    is_agent
    deleted
    is_admin
    visible_on_website
    starting_date
    termination_date
    yrs_at_strive
    birth_date
    age
    on_phones
    in_pool
    first_listing
    first_closing
    address
    city
    arcimedes_created
    arcimedes_created_by
    arcimedes_modified
    arcimedes_modified_by
  }
}
`
